import React from "react";

interface NullProps {
  className?: string;
  width?: number;
  fill?: string;
  height?: number;

}
const IconNull: React.FC<NullProps> = ({
  className,
  width,
  height,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width={width}
    height={height}
    viewBox="-0.125 -0.125 1.5 1.5" preserveAspectRatio="xMinYMin" ><path d="M.625 1.25a.625.625 0 1 1 0-1.25.625.625 0 0 1 0 1.25m0-.125a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m0-.625a.063.063 0 0 1 .063.063v.313a.063.063 0 0 1-.125 0V.563A.063.063 0 0 1 .626.5m0-.063a.063.063 0 1 1 0-.125.063.063 0 0 1 0 .125" /></svg>
);
export default IconNull;
